module.exports = "precision mediump float;\r\n\r\nvarying vec2 vTextureCoord;\r\nvarying vec2 vFilterCoord;\r\n\r\nuniform sampler2D previousTexture;\r\nuniform sampler2D uSampler;\r\n\r\nvoid main(void)\r\n{\r\n    gl_FragColor = texture2D(previousTexture, vFilterCoord);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/transition/shaders/prepare.frag
// module id = 599
// module chunks = 0